import { useEffect, useState } from "react";
import "./index.css";
import PortalLayout from "./Components/PortalLayout";
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { Toaster } from "react-hot-toast";

// Medical Services
import MedicalServices from "./Pages/Account/MedicalServices/MedicalServices";
import AddEditMedicalService from "./Pages/Account/MedicalServices/AddEditMedicalService";

// Lab Test Services
import LabTest from "./Pages/Account/Labtest/labtest";
import LabServices from "./Pages/Account/Labtest/labservices";

// Other Pages
import AddEditMedicalStore from "./Pages/Account/PurchaseMedicine/AddEditMedicalStore";
import Income from "./Pages/Account/Income/Income";
import Login from "./Pages/Login/Login";
import Expense from "./Pages/Account/Expense/Expense";
import AddEditIncome from "./Pages/Account/Income/AddEditIncome";
import AddEditExpense from "./Pages/Account/Expense/AddEditExpense";
import OtherIncome from "./Pages/Account/Income/OtherIncome";
import AddEditExpenseHead from "./Pages/Account/Expense/AddEditExpenseHead";
import MedicineStock from "./Pages/Account/PurchaseMedicine/MedicineStock";
import RecordPurchases from "./Pages/Account/PurchaseMedicine/RecordPurchases";
import Sales from "./Pages/Account/Sales/Sales";
import ServicesSales from "./Pages/Account/ServicesSales/ServicesSales";
import PatientSalesAll from "./Pages/Account/Pateintsales/PatientSalesAll";
import AddPurchase from "./Pages/Account/NewPurchaseMedicine/AddPurchase";
import AddLabtest from "./Pages/Account/Labtest/AddLabtest";
import Equipments from "./Pages/Account/Equipments/Equipment";
import AddEquipments from "./Pages/Account/Equipments/AddEquipments";
import UpdateEquipments from "./Pages/Account/Equipments/UpdateEquipments";
import HospitalStructure from "./Pages/Account/HospitalStructure/HospitalStructure";
import AddHospitalStructure from "./Pages/Account/HospitalStructure/AddHospitalStructure";
import UpdateHospitalStructure from "./Pages/Account/HospitalStructure/UpdateHospitalStructure";
import Attendence from "./Pages/Account/Attendence/Attendence";
// import AddAttendence from "./Pages/Account/Attendence/AddAttendence";
// import UpdateAttendence from "./Pages/Account/Attendence/UpdateAttendence";
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("Q0FUSU9OOQUNVU1RPTUVSLUFVVEhFTlRJIMSLQ1JFVC1LR=");
    setIsAuthenticated(!!token);
  }, [location.pathname]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      <Toaster />
      <Routes>
        <Route path="/" element={<Navigate to="/account/medicinestock" replace />} />

        {/* Login */}
        <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/account/medicinestock" />} />

        {/* Medicine Stock */}
        <Route path="/account/medicinestock" element={isAuthenticated ? <PortalLayout><MedicineStock /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/medicinestock/purchasemedicine" element={isAuthenticated ? <PortalLayout><AddEditMedicalStore /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/medicinestock/purchasemedicine/:id" element={isAuthenticated ? <PortalLayout><AddEditMedicalStore /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/medicinestock/recordpurchases" element={isAuthenticated ? <PortalLayout><RecordPurchases /></PortalLayout> : <Navigate to="/login" />} />

        {/* Add Purchase */}
        <Route path="/account/addpurchase" element={isAuthenticated ? <PortalLayout><AddPurchase /></PortalLayout> : <Navigate to="/login" />} />

        {/* Medical Services */}
        <Route path="/account/medicalservices" element={isAuthenticated ? <PortalLayout><MedicalServices /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/medicalservices/saleservice" element={isAuthenticated ? <PortalLayout><AddEditMedicalService /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/medicalservices/saleservice/:id" element={isAuthenticated ? <PortalLayout><AddEditMedicalService /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/medicalservices/recordservices" element={isAuthenticated ? <PortalLayout><RecordPurchases /></PortalLayout> : <Navigate to="/login" />} />

        {/* Lab Test Services */}
        <Route path="/account/Labtest/labtest" element={isAuthenticated ? <PortalLayout><LabTest /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/Labtest/labtest/labtestservice" element={isAuthenticated ? <PortalLayout><LabServices /></PortalLayout> : <Navigate to="/login" />} />

        {/* Sales */}
        <Route path="/account/sales" element={isAuthenticated ? <PortalLayout><Sales /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/servicesales" element={isAuthenticated ? <PortalLayout><ServicesSales /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/patientsales" element={isAuthenticated ? <PortalLayout><PatientSalesAll /></PortalLayout> : <Navigate to="/login" />} />

        {/* Income & Expense */}
        <Route path="/account/income" element={isAuthenticated ? <PortalLayout><Income /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/income/AddEditIncome" element={isAuthenticated ? <PortalLayout><AddEditIncome /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/income/OtherIncome" element={isAuthenticated ? <PortalLayout><OtherIncome /></PortalLayout> : <Navigate to="/login" />} />

        <Route path="/account/expense" element={isAuthenticated ? <PortalLayout><Expense /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/expense/AddEditExpense" element={isAuthenticated ? <PortalLayout><AddEditExpense /></PortalLayout> : <Navigate to="/login" />} />
        <Route path="/account/expense/AddEditExpenseHead" element={isAuthenticated ? <PortalLayout><AddEditExpenseHead /></PortalLayout> : <Navigate to="/login" />} />
         <Route path="/account/equipment" element={isAuthenticated ? <PortalLayout><Equipments /></PortalLayout> : <Navigate to="/login" />} />
          <Route path="/account/equipment/add" element={isAuthenticated ? <PortalLayout><AddEquipments /></PortalLayout> : <Navigate to="/login" />} />

           {/* <Route path="/account/equipment/update" element={isAuthenticated ? <PortalLayout><UpdateEquipments /></PortalLayout> : <Navigate to="/login" />} /> */}
            <Route path="/account/equipment/update/:id" element={isAuthenticated ? <PortalLayout><UpdateEquipments /></PortalLayout> : <Navigate to="/login" />} />

          <Route path="/account/Labtest/labtest/addlabtest" element={isAuthenticated ? <PortalLayout><AddLabtest /></PortalLayout> : <Navigate to="/login" />} />
          <Route
  path="/account/Labtest/labtest/addlabtest/:id"
  element={isAuthenticated ? <PortalLayout><AddLabtest /></PortalLayout> : <Navigate to="/login" />}
/>

          <Route path="/account/hospitalstructure" element={isAuthenticated ? <PortalLayout><HospitalStructure /></PortalLayout> : <Navigate to="/login" />} />
          <Route path="/account/hospitalstructure/add" element={isAuthenticated ? <PortalLayout><AddHospitalStructure /></PortalLayout> : <Navigate to="/login" />} />
          <Route path="/account/hospitalstructure/update/:id" element={isAuthenticated ? <PortalLayout><UpdateHospitalStructure /></PortalLayout> : <Navigate to="/login" />} />

<Route path="/account/Attendence" element={isAuthenticated ? <PortalLayout><Attendence /></PortalLayout> : <Navigate to="/login" />} />
          {/* <Route path="/account/Attendence/add" element={isAuthenticated ? <PortalLayout><AddAttendence /></PortalLayout> : <Navigate to="/login" />} /> */}

      </Routes>
    </>
  );
}

export default App;
